import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuickApplyCriteria } from "src/redux/quickApplyCriteria/action";
import getCandidateInformation, {
  OnboardingInfo,
} from "src/components/common/CandidateInformation/CandidateInformation";
import config from "src/config";

interface RootState {
  auth: {
    email: string;
  };
  company: {
    company: {
      id: string;
    };
  };
  onBoarding: OnboardingInfo;
  candidate: {
    atsBullhornCandidateId: string;
    bullhornIdFromBullhorn: string;
  };
}

const enableSsnAndDobFields = config.ENABLE_SSN_AND_DOB_FIELDS === "true"; 

const FetchTheQuickApplyCriteria = () => {
  const dispatch = useDispatch();

  const email = useSelector((state: RootState) => state.auth.email);
  const companyId = useSelector((state: RootState) => state.company.company.id);

  const profession = useSelector(
    (state: RootState) =>
      state.onBoarding?.onboardingInformation?.onboarding?.specialtiesAndEducation?.specialty
        ?.profession
  );
  const onboardingInfo = useSelector((state: RootState) => state.onBoarding);
  const atsBullhornCandidateId = useSelector(
    (state: RootState) => state.candidate.atsBullhornCandidateId
  );
  const bhId = useSelector((state: RootState) => state.candidate.bullhornIdFromBullhorn);

  useEffect(() => {
  const externalCandidateId = atsBullhornCandidateId || bhId;
 if (!email || !companyId || !externalCandidateId || !profession || !onboardingInfo) return;     
  const candidateInformation = getCandidateInformation(onboardingInfo);
  if (!candidateInformation) return;

  dispatch(
    fetchQuickApplyCriteria({
      email,
      companyId: Number(companyId),
      externalCandidateId: Number(externalCandidateId),
      profession,
      specialties: [],
      locations: [],
      isCityStates: true,
      includeSsnAndDob: enableSsnAndDobFields,
      candidateInformation,
    })
  );
}, [profession, onboardingInfo, dispatch]);

return null;
};

export default withTranslation()(FetchTheQuickApplyCriteria);
